import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import { Spin } from "antd";
import SiderDemo from "./Components/Menu";
import Hr from "./Components/Hr";
import Signin from "./pages/Auth/Signin";
import Report from "./pages/Report";
import Settings from "./pages/Settings";
import { startUp } from "./slices/authentication.slice";
import HrDetail from "./pages/hrDetail";
import { exhangeGet } from "./slices/util.slice";
import AuthType from "./pages/Auth/Permission";
import { getRoleHome, normalizeRole } from "./pages/Auth/PermissionType";
import Patient from "./pages/Patient";
import PatientDetail from "./Components/client/PatientDetail";
import Blog from "./pages/Blog";
import Faq from "./pages/Faq";
import Comparission from "./pages/Comparission";
import NewFaq from "./pages/NewFaq";
import Instruction from "./pages/Instruction";
import Tutorial from "./pages/Tutorial";
import InstructionText from "./pages/instructionText";
import Reels from "./pages/Reels";
import Notify from "./pages/Notify";

const LabPage = React.lazy(() => import("./pages/LabPage"));
const Cliche = React.lazy(() => import("./pages/Cliche"));
const UpcomeTest = React.lazy(() => import("./pages/UpcomeTest"));
const Notes = React.lazy(() => import("./pages/Notes"));

function RoleLanding() {
  const role = useSelector((state) => state.auth.auth.role);
  const normalized = normalizeRole(role);
  if (normalized === "application" || normalized === "admin") {
    return <Patient />;
  }
  return <Navigate to={getRoleHome(role)} replace />;
}

function App() {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state.auth);

  useEffect(() => {
    async function firstLoad() {
      await dispatch(exhangeGet());
      dispatch(startUp());
    }

    firstLoad();
  }, [dispatch]);

  if (!selector.status) {
    return <Spin style={{ position: "absolute", left: "50%", top: "50%", transform: "translate(-50,-50%)" }} />;
  } else {
  return (
    <Routes>
      <Route path="/Login" element={<Signin />} />

      {selector.auth.id ? (
        <Route path="/" element={<SiderDemo />}>
          <Route index element={<RoleLanding />} />

          <Route element={<AuthType allowedRoles={["admin", "lab", "Secretary"]} />}>
            <Route path="Patient" element={<Patient />} />
            <Route path="LabPage" element={<React.Suspense fallback={<Spin />}><LabPage /></React.Suspense>} />
            <Route path="Cliche" element={<React.Suspense fallback={<Spin />}><Cliche /></React.Suspense>} />
            <Route path="Cliche/:id" element={<React.Suspense fallback={<Spin />}><UpcomeTest /></React.Suspense>} />
          </Route>

          <Route path="Patient/:id" element={<PatientDetail />} />
          <Route element={<AuthType allowedRoles={["admin"]} />}>
            <Route path="HR" element={<Hr />} />
          </Route>

          <Route path="HR/:id" element={<HrDetail />} />

          <Route element={<AuthType allowedRoles={["admin", "note"]} />}>
            <Route path="Note" element={<React.Suspense fallback={<Spin />}><Notes /></React.Suspense>} />
          </Route>

          <Route element={<AuthType allowedRoles={["admin"]} />}>
            <Route path="/Report" element={<Report />} />
          </Route>

          <Route element={<AuthType allowedRoles={["application", "admin"]} />}>
            <Route path="/Notify" element={<Notify />} />
          </Route>

          <Route element={<AuthType allowedRoles={["application", "admin"]} />}>
            <Route path="/Camparission" element={<Comparission />} />
          </Route>

          <Route element={<AuthType allowedRoles={["application", "admin"]} />}>
            <Route path="/Reels" element={<Reels />} />
          </Route>

          <Route element={<AuthType allowedRoles={["application", "admin"]} />}>
            <Route path="/Blog" element={<Blog />} />
          </Route>

          <Route element={<AuthType allowedRoles={["application", "admin"]} />}>
            <Route path="/FAQ" element={<Faq />} />
          </Route>

          <Route element={<AuthType allowedRoles={["application", "admin"]} />}>
            <Route path="/InstructionVideos" element={<Instruction />} />
          </Route>


          <Route element={<AuthType allowedRoles={["application", "admin"]} />}>
            <Route path="/InstructionText" element={<InstructionText />} />
          </Route>

          <Route path="/FAQ/:id" element={<NewFaq />} />
          <Route path="Tutorial" element={<Tutorial />} />
          <Route path="Settings" element={<Settings />} />
          <Route path="/FAQ/new" element={<NewFaq />} />
          <Route path="cliche" element={<Navigate to="/Cliche" replace />} />
        </Route>
      ) : (
        <Route path="*" element={<Navigate to="/Login" />} />
      )}
    </Routes>
  );
  }
}

export default App;
